import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MeLoadState, MeStore } from './auth.me.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
@Component({
  selector: 'app-root',
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'Todo app. With MCP!';
  
  readonly meStore = inject(MeStore);
  constructor() {
    this.meStore.reloadMeRx(toObservable(this.meStore.meLoadState).pipe(filter(state => state === MeLoadState.ReloadMe)));
    this.meStore.reloadMe();
  } 
}
